import type { ClientIntakeFormContext } from '@models/client-intake';
import type { Client } from '@models/clients';

export class UpsertIntakeFormContext {
	static readonly type = '[Intake Form Context] Upsert intake form context';
	constructor(public context: ClientIntakeFormContext) {}
}

export class AddRemoveClientContext {
	static readonly type = '[Intake Form Context] Add/Remove client context';
	constructor(
		public payload: {
			currentContext: ClientIntakeFormContext;
			clients: Client[];
		},
	) {}
}
